import { render } from "./DeleteFiltersModal.vue?vue&type=template&id=5c8dc37d"
import script from "./DeleteFiltersModal.vue?vue&type=script&lang=js"
export * from "./DeleteFiltersModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__